import { getCreditCardBrandsIcons } from "../../utils/utils/get-creditcard-brands-icons.js";
import { getPaymentMethodIcon } from "../../utils/utils/get-payment-method-icon.js";
import { getBankIcon } from "../../utils/utils/get-bank-icons.js";
import { PaymentMethod } from "../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const cartPaymentMethods = ({ cartPaymentMethods: cartPaymentMethods2 }, isApplePayActive = false) => (cartPaymentMethods2 || [])?.reduce(
  (acc, {
    name,
    psp,
    paymentMethodPrice,
    issuers,
    brands,
    installmentTypes,
    donations,
    configuration = []
  }) => {
    if (!isApplePayActive && name === PaymentMethod.APPLE_PAY) {
      return acc;
    }
    const expressPaymentMethods = [PaymentMethod.APPLE_PAY, PaymentMethod.GOOGLE_PAY];
    const icons = brands?.length && !expressPaymentMethods.includes(name) ? getCreditCardBrandsIcons(brands) : getPaymentMethodIcon(name);
    const paymentMethod = {
      name,
      provider: psp,
      ...icons?.length && {
        icons
      },
      ...paymentMethodPrice && {
        paymentMethodPrice
      },
      ...issuers?.length && {
        items: issuers.map(({ id, name: name2 }) => ({
          key: id,
          value: name2,
          icon: getBankIcon(name2)
        }))
      },
      ...brands?.length && {
        brands
      },
      ...installmentTypes?.length && {
        items: installmentTypes.map(({ id, installments }) => ({
          key: id,
          value: String(installments)
        }))
      },
      ...donations?.length && {
        donations
      },
      ...configuration && {
        configuration
      }
    };
    return [...acc, paymentMethod];
  },
  []
);
export {
  cartPaymentMethods
};
//# sourceMappingURL=cart-payment-methods.js.map
